import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "links" }
const _hoisted_2 = { class: "settings" }

import { toggleTheme } from "@/modules/ThemeToggle";

export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Home")
          ])),
          _: 1,
          __: [1]
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/games" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Spellen")
          ])),
          _: 1,
          __: [2]
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args))),
          class: "theme-switch",
          "aria-label": "Toggle Theme"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fa-solid fa-circle-half-stroke" }, null, -1)
        ]))
      ])
    ])
  ]))
}
}

})